import { css } from '@emotion/css';
import {
  extraLargeDesktopWidth,
  m,
  mobileMediaQuery,
} from '@snapchat/snap-design-system-marketing';

export const slugContainerCss = css`
  display: flex;
  width: 100%;
  justify-content: left;
  margin: auto;
  max-width: ${extraLargeDesktopWidth}px;

  html[dir='rtl'] & {
    justify-content: right;
  }

  ${mobileMediaQuery} {
    display: block;
  }
`;

/**
 * Give the slug a default gutter color so the gutter doesn't flicker. Unfortunately does not work
 * if the page background color is set to a different color But handles the default case well
 */
export const slugGutterCss = css`
  ::before {
    background-color: ${m('--gutter-color')};
    content: '';
    height: 100vh;
    inset: 0;
    position: fixed;
    width: 100vw;
    z-index: -10;
  }
`;

export const slugContainerWithSideNavCss = css`
  overflow: clip;
`;

export const minHeightCss = css`
  min-height: calc(100vh - var(--total-header-height));
  min-height: calc(100dvh - var(--total-header-height));
`;
